export default {
  rankOrder: {
    ariaAddOption: 'เพิ่ม {label} ในรายการจัดอันดับ',
    ariaMoveUp: 'เลื่อน {label} ขึ้น',
    ariaMoveDown: 'เลื่อน {label} ลง',
    ariaRemoveOption: 'นำ {label} ออกจากรายการจัดอันดับ',
  },
  coe: {
    ariaDisclaimer: 'ข้อความแจ้งเตือน',
    ariaQuestion: 'คำถาม',
    ariaConversationHistory: 'ประวัติการสนทนา',
    ariaYourResponse: 'คำตอบของคุณ {number}',
    ariaFollowUpQuestion: 'คำถามติดตาม {number}',
    ariaResponseInput: 'ช่องกรอกคำตอบ',
    ariaRespondingTo: 'กำลังตอบ',
    ariaSendResponse: 'ส่งคำตอบ',
    ariaThinking: 'กำลังคิด'
  },
  deviceView: {
    toolbar: 'อุปกรณ์แสดงตัวอย่าง',
    mobile: 'มือถือ',
    tablet: 'แท็บเล็ต',
    desktop: 'เดสก์ท็อป'
  },
  header: {
    customLogoAlt: 'โลโก้',
    defaultLogoAlt: 'โลโก้ QuestDIY'
  }
}
